import { render } from "./ImageViewerHeader.vue?vue&type=template&id=16b69ce5&scoped=true&ts=true"
import script from "./ImageViewerHeader.vue?vue&type=script&lang=ts"
export * from "./ImageViewerHeader.vue?vue&type=script&lang=ts"

import "./ImageViewerHeader.vue?vue&type=style&index=0&id=16b69ce5&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b69ce5"]])

export default __exports__